import pluralize from 'scripts/utils/pluralize'

export const shipmentsDictionary = {
  today: 'Entrega',
  express: 'Entrega',
  marketplace_express: 'Entrega',
  pickupInStore: 'Retire na loja',
  scheduled: 'Agende para entrega',
  lespace_ad_scheduled: 'Agende para entrega',
  marketplace_scheduled: 'Agende para entrega',
  standard: 'Entrega'
}

const LABELS_WITHOUT_DEADLINE = ['scheduled', 'lespace_ad_scheduled', 'marketplace_scheduled', 'pickupInStore']

export const getShipmentMessage = (modality, deadline) => {
  const label = deadline === 0 ? 'today' : modality

  const getDeadlineMessage = () => {
    if (!deadline) {
      return {
        prefix: 'no',
        main: 'mesmo dia'
      }
    }

    if (!LABELS_WITHOUT_DEADLINE.includes(label)) {
      const workDaysText = `${deadline} ${pluralize(deadline, 'shipmentDeadline')}`
      return {
        prefix: 'em até',
        main: workDaysText
      }
    }

    return ''
  }

  return {
    label: shipmentsDictionary[label],
    deadlineMessage: getDeadlineMessage()
  }
}

export const workDaysText = (workDays) => {
  switch (workDays) {
    case 0:
      return {
        prefix: null,
        deadline: 'hoje'
      }

    case 1:
      return {
        prefix: 'em até',
        deadline: '1 dia útil'
      }

    default:
      return {
        prefix: 'em até',
        deadline: `${workDays} dias úteis`
      }
  }
}
